import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateUserNotificationPreferenceRequest } from '../../api/create-user-notification-preference/createUserNotificationPreferenceRequest.types';
import type { UseCreateUserNotificationPreferenceResult } from './useCreateUserNotificationPreference.types';

import { createUserNotificationPreference } from '../../api/create-user-notification-preference/createUserNotificationPreference';

export function useCreateUserNotificationPreference(): UseCreateUserNotificationPreferenceResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, CreateUserNotificationPreferenceRequest>({
    mutationFn: (
      data: CreateUserNotificationPreferenceRequest
    ): Promise<void> => createUserNotificationPreference(data),
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({
        queryKey: ['user-notification-preferences'],
      });
    },
  });
}
